<template>
  <div class="h-100 d-flex flex-column">
    <div class="sidebar-item" v-bind:class="{ 'disabled': isActive === false}">
      <div class="d-flex align-items-center gap-20 justify-content-between">
        <div class="d-flex gap-20 align-items-center">
          <span class="main-number"
                v-bind:class="{ 'disabled': isActive === false, 'done': isActive === false}">1</span> <span
            class="font-size-125">{{ "Upload your image" | trans }}</span></div>
        <div @click="item_open = !item_open">
        </div>
      </div>
    </div>

    <div class="sidebar-item d-flex flex-1">
      <div class="alert alert-info">Upload the image you want to edit using AI Magic Editor</div>

      <div class="h-100 flex-1 " v-if="item_open === true && isActive === true">
        <div class="upload-box-item h-100">
          <upload-box></upload-box>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import UploadBox from "../../Elements/UploadBox.vue";

export default {
  name: "UploadItemMedium",
  props: {},
  components: {UploadBox},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      item_open: true
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {
    isActive() {
      return this.activeStage.mainJob === null;
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-box-item {
  flex:1;
}
</style>
